import type { Infer } from 'superstruct';
import { integer, object } from 'superstruct';

/** Any object that has an id. */
export const IdObject = object({ id: integer() });

export type IdObject = Infer<typeof IdObject>;
